import Vue from 'vue'
// import iView from 'iview';
import Util from '../libs/util'
import VueRouter from 'vue-router'
import Cookies from 'js-cookie'
import { routers, otherRouter, appRouter, page404 } from './router'

import panguComponentRouter from './panguComponentRouter'

Vue.use(VueRouter)
//增加，自定义的组件
let routersAll = routers.concat(panguComponentRouter)
//page404必须放到路由最后，否则不是精确匹配
routersAll.push(page404)

// 路由配置
const RouterConfig = {
  // mode: 'history',
  routes: routersAll,
}
console.log('RouterConfig', RouterConfig)
export const router = new VueRouter(RouterConfig)

router.beforeEach((to, from, next) => {
  router.app.$Loading.start()
  Util.title(to.meta.title)
  console.log(to)
  const curRouterObj = Util.getRouterObjByName([otherRouter, ...appRouter], to.name)
  if (curRouterObj && curRouterObj.access !== undefined) {
    // 需要判断权限的路由
    if (curRouterObj.access === parseInt(Cookies.get('access'))) {
      Util.toDefaultPage([otherRouter, ...appRouter], to.name, router, next) // 如果在地址栏输入的是一级菜单则默认打开其第一个二级菜单的页面
    } else {
      next({
        replace: true,
        name: 'error-403',
      })
    }
  } else {
    // 没有配置权限的路由, 直接通过
    Util.toDefaultPage([...routers], to.name, router, next)
    // 显示路由，方便定位
    console.log('route->', to)
    if (to.path === '/home') {
      //当路由为home时默认转到第一个菜单
      next({
        replace: true,
        name: 'index_home',
        query: to.query,
      })
    }
  }
})

router.afterEach((to) => {
  Util.openNewPage(router.app, to.name, to.params, to.query)
  router.app.$Loading.finish()
  window.scrollTo(0, 0)
})
